export const DownloadFromFile = async (file: File, filename: string) => {
  const blobFile = new Blob([file]);
  const aElement = document.createElement('a');
  aElement.href = URL.createObjectURL(blobFile);
  aElement.setAttribute('download', filename);
  aElement.click();
};
